import React, { Component }  from 'react';
import Footer from '../components/layout/footer';
import Header from '../components/layout/header';
import AboutUs from '../components/section/about_us';
import AcademicsPage from '../components/section/academics';
import Beyond from '../components/section/beyond_academics';
import Career from '../components/section/career';
import Cbse from '../components/section/cbse';
import Infrastructure from '../components/section/infrastructure';
import LifeAtInnovera from '../components/section/life_at_innovera';
  import config from '../constant';


class AcademicsMain extends Component {
    componentDidMount(){
        document.title = "Academics | " + config.SIE_NAME
      }
        render(){
    return(
        <div>
            <Header/>
            <AcademicsPage/>
             <Footer/>


        </div>
    );

}
    }
export default AcademicsMain;